export default __webpack_public_path__ + "static/media/email.90b1f1ab.svg";